import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

var tokenid = localStorage.getItem("tokenid");
var httpURL = lstModules['main'].url + ":" + lstModules['main'].port;

export function getClassListSvc(callback1) {
    axios({
        url: httpURL + '/sms/cls/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        callback1(response.data);
    }).catch((error) => {
        callback1(error);
    });
}
export function getSectionListSvc(callback2, pClassId) {
    axios({
        url: httpURL + "/sms/cls/sec/list",
        method: "POST",
        params: { classId: pClassId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        callback2(response.data);
    }).catch((error) => {
        callback2(error);
    });
}


export const subjectDaysPeriodListSvc = (pSectionId, callback) => {
    // console.log("subjectTeacherListSvc called, pSectionId", pSectionId);
    const formData = new FormData();
    formData.append("sectionId", pSectionId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/class_subject/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in subjectTeacherListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstSubject = response.data.lstSubject;
        }
        callback(obj, pSectionId);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const periodListSvc = (sectionId, callback) => {
    // console.log("subjectTeacherListSvc called, sectionId", sectionId);
    const formData = new FormData();
    formData.append("sectionId", sectionId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/class_subject/list_period',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in subjectTeacherListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPeriod = response.data.lstPeriod;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const saveSubjectDaysPeriodsSvc = (obj, callback) => {
    // console.log("saveSubjectDaysPeriodsSvc called, sectionId", sectionId);
    const formData = new FormData();
    
    formData.append("sectionSubjectObj", JSON.stringify(obj));
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/class_subject/save',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveSubjectDaysPeriodsSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const resetSubjectDaysPeriodsSvc = (obj, callback) => {
    // console.log("saveSubjectDaysPeriodsSvc called, pSectionId", pSubjectId);
    const formData = new FormData();
    
    formData.append("sectionSubjectObj", JSON.stringify(obj));
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/class_subject/clear',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveSubjectDaysPeriodsSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
